/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ModuleDraftOutput } from './moduleDraftOutput';

/**
 * Output: The drafted module.
 */
export interface ContentStudioStage3Response {
  moduleDraft: ModuleDraftOutput;
}
